module.exports = __webpack_public_path__ + "ty6-a8ae1df4.png";